import {localStorageKey} from "@/api/config.js";
import {getTokenObj, loginTokenSet, logout} from "@/mixins/Auth.js";
import moment from "moment";
import Api from "@/api/index.js";

class AutoLoginCheckIn {
    autoLoginCheckInName = `${localStorageKey}checkInAutoLogin`;
    isRunning = false;

    _getNowCheckInDate() {
        return moment().set('h', 0).set('m', 0).set('s', 0).set('ms', 0).unix();
    }

    async autoLoginCheckIn() {
        if (this.isRunning) return;
        let tokenObj = getTokenObj();
        if (!tokenObj.hasOwnProperty('mb_no')) return;
        this.isRunning = true;
        let checkInDate = this._getNowCheckInDate();
        let beforeCheckInDate = localStorage.getItem(this.autoLoginCheckInName);
        if (beforeCheckInDate != null) {
            beforeCheckInDate = Number(beforeCheckInDate);
        }
        if (beforeCheckInDate != null && checkInDate >= beforeCheckInDate) {
            this.isRunning = false;
            return true;
        }
        let possibleCheckIn = await this._checkAutoLoginCheckIn();
        if (!possibleCheckIn) {
            this.isRunning = false;
            return true
        }
        let checkIn = await this._autoLoginCheckIn();
        if (!checkIn) {
            logout();
            return false;
        }
        localStorage.setItem(this.autoLoginCheckInName, `${checkInDate}`);
        this.isRunning = false;

    }

    _checkAutoLoginCheckIn() {
        return Api.$auth.autoLoginCheckInCheck().then(res => {

            if (res.code === -1) return true;
            let checkInDate = this._getNowCheckInDate();
            localStorage.setItem(this.autoLoginCheckInName, `${checkInDate}`);
            return false;
        })
    }

    async _autoLoginCheckIn() {
        try {
            let params = await this._returnAutoLoginParams();
            return Api.$auth.autoLoginCheckIn(params).then(res =>{
                if (res.code === 1) {
                    let token = res.result.data.token;
                    loginTokenSet(token);
                    return true;
                }
                return false;
            })
        } catch (e) {
            return false;
        }
    }

    _returnAutoLoginParams() {
        return new Promise(async resolve => {
            let params = {
                lpType: 'web',
            }
            resolve(params)
            return params;
        })
    }


}

export default AutoLoginCheckIn
